import React, { Component } from 'react';
import { Card, Col, message, Row } from 'antd';
import { browserHistory } from 'react-router';
import {
  queryCallbackTermination,
  queryDeleteTermination,
  queryNextTermination,
  queryNextTerminationArchive,
  queryNextTerminationScan,
  queryReturnTermination,
  querySaveTermination,
} from '@api/incubator/termination';
import Process from '@comm/workflow/Process';
import ProcessHistory from '@comm/workflow/ProcessHistory';
import Opration from '@comm/workflow/incubatorScan/WorkflowInc';
import Comment from '@comm/comment/Index';

import moment from 'moment';
import FormOpen from './FormOpen';

class Page extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataInfo: {},
      payables: props.payables,
      isLoading: false,
    };
  }

  componentWillMount() {}

  componentDidMount() {
    const { data } = this.props;
    this.setState({ dataInfo: data });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataInfo: nextProps.data,
    });
  }

  /**
   * 提交报销
   */
  handSubmit = (item, type) => {
    if (type === 'save') {
      this.terminationSave(item);
    }
  };

  /**
   * 保存
   */
  terminationSave = item => {
    querySaveTermination(item).then(res => {
      if (res.statusCode === 200) {
        message.success('保存成功');
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  /**
   * 处理流程
   */
  doTask = (pass, refuse, info) => {
    const { dataInfo } = this.state;
    const instance = dataInfo.instance || {};
    const item = {
      instanceUuid: instance.uuid,
    };
    switch (pass) {
      case 'callback':
        this.terminationCallback(item);
        break;
      case 'delete':
        this.terminationDelete({ uuid: dataInfo.uuid });
        break;
      case 'next':
        this.terminationNext(item);
        break;
      case 'nextScan':
        this.terminationNextlScan({
          ...item,
          ...info,
        });
        break;
      case 'nextArchive':
        this.terminationNextArchive({
          ...item,
          ...info,
        });
        break;
      case 'return':
        this.terminationReturn(item, refuse);
        break;
      default:
        break;
    }
  };

  // 收回
  terminationCallback = params => {
    queryCallbackTermination(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  // 收回
  terminationDelete = params => {
    queryDeleteTermination(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  // 通过
  terminationNext = params => {
    this.setState({ isLoading: true });
    queryNextTermination(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
        this.setState({ isLoading: false });
      } else {
        message.error(res.message);
        this.setState({ isLoading: false });
      }
    });
  };

  // 扫描件通过
  terminationNextlScan = params => {
    this.setState({ isLoading: true });
    queryNextTerminationScan(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
        this.setState({ isLoading: false });
      } else {
        message.error(res.message);
        this.setState({ isLoading: false });
      }
    });
  };

  // 行政归档通过
  terminationNextArchive = params => {
    this.setState({ isLoading: true });
    queryNextTerminationArchive(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
        this.setState({ isLoading: false });
      } else {
        message.error(res.message);
        this.setState({ isLoading: false });
      }
    });
  };

  // 打回
  terminationReturn = (params, refuse) => {
    queryReturnTermination({
      ...params,
      ...refuse,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.go(-1);
      } else {
        message.error(res.message);
      }
    });
  };

  handleCancel = () => {};

  /**
   * 查看流程
   */
  watchTask = () => {};

  columns = () => {
    return [
      {
        title: '日期',
        dataIndex: 'date',
        render: text => (
          <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null}</span>
        ),
      },
      {
        title: '操作内容',
        dataIndex: 'operating',
      },
      {
        title: '处理意见',
        dataIndex: 'refuse',
      },
    ];
  };

  render() {
    const { dataInfo, payables, isLoading } = this.state;
    const instance = dataInfo.instance || {};
    const histories = dataInfo.histories || [];
    return (
      <div>
        <Opration
          op="scanArchive"
          data={dataInfo}
          handSubmit={this.handSubmit}
          doTask={this.doTask}
          watchTask={this.watchTask}
          isLoading={isLoading}
        />
        <FormOpen
          data={dataInfo}
          payables={payables}
          handSubmit={this.handSubmit}
          doTask={this.doTask}
          watchTask={this.watchTask}
          {...this.props}
        />
        <Card title="流程跟踪">
          <Row justify="center">
            <Col span={24} style={{ marginBottom: '16px', fontSize: '14px' }}>
              <div style={{ marginBottom: '16px', fontSize: '14px' }}>流程路径：</div>
              <Process instance={instance} />
            </Col>
            <Col span={24}>
              <ProcessHistory dataSource={histories} />
            </Col>
          </Row>
        </Card>
        <Comment target={{ type: 'incubatorTerminationStation', uuid: dataInfo.uuid }} />
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/incubator/termination/station/PageOpen.js